import { useEffect } from 'react'

/**
 * Replaces `ViewData["Title"]`.
 *
 * The two layouts formatted it differently — _Layout used
 * `E-Career - {title}` and _LoginLayout used `{title} | E-Career` — so the
 * variant is a parameter rather than hardcoded.
 */
export function usePageTitle(title: string, variant: 'app' | 'auth' = 'app'): void {
  useEffect(() => {
    document.title = variant === 'auth' ? `${title} | E-Career` : `E-Career - ${title}`
  }, [title, variant])
}
